import React, { useContext, useState } from "react"
import { Div, Col, Row, Text } from "atomize"
import PrimaryButton from "../buttons/PrimaryButton"
import SecondaryButton from "../buttons/SecondaryButton"
import { theme } from "../settings/config"
import Container from "../atoms/Container"
import Lesson from "../Lesson"
import RadioBox from "../atoms/RadioBox"
import { restoreLesson } from "../utils/firestore.utils"
import { lessonsContext } from "../providers/lessons.provider"
import { sharedDataContext } from "../providers/sharedData.provider"
import { toast } from "react-toastify"
import { networkAwareMessage } from "../utils/network.utils"

// Una lezione annullata torna com'era: allievi e presenze di prima
// dell'annullamento, i pagamenti di chi pagava la volta, l'evento su Google
// Calendar. Se era stata riprogrammata si chiede cosa fare del recupero.
export function RestoreLessonModal({ closeModal, lessonData }) {
	const { removeLessonFromCache, invalidateDate } = useContext(lessonsContext)
	const { getLessonType } = useContext(sharedDataContext)

	const [isRestoring, setRestoringState] = useState(false)
	const wasRescheduled = Boolean(lessonData.rescheduledLessonID)
	const [deleteRescheduled, setDeleteRescheduled] = useState(true)

	const restore = () => {
		setRestoringState(true)
		// il titolo dell'evento lo fa restoreLesson, dagli allievi ripristinati:
		// da qui serve solo il nome del tipo di lezione
		restoreLesson(lessonData, {
			deleteRescheduled: wasRescheduled && deleteRescheduled,
			lessonTypeName: getLessonType(lessonData.lessonType)?.lessonTypeName ?? "",
		})
			.then(({ deletedRescheduledDate }) => {
				console.info("Lezione ripristinata", lessonData.lessonID)
				if (deletedRescheduledDate) {
					removeLessonFromCache({
						schoolID: lessonData.schoolID,
						date: deletedRescheduledDate,
						coachID: lessonData.coachID,
						lessonID: lessonData.rescheduledLessonID,
					})
					invalidateDate(deletedRescheduledDate, lessonData.schoolID)
				}
				closeModal()
			})
			.catch(error => {
				console.error("Lezione non ripristinata:", error)
				const message = networkAwareMessage(
					error,
					"Non è stato possibile ripristinare la lezione",
				)
				toast.error(message, { toastId: message, position: "top-center" })
			})
			.finally(() => setRestoringState(false))
	}

	return (
		<Container>
			<Div
				d="flex"
				justify="space-between"
				m={{ b: "0.5rem" }}
				textWeight="bold"
				textSize="title"
				textColor={theme === "light" ? "text" : "text_alt"}>
				Ripristinare la lezione?
			</Div>
			<Lesson lessonData={lessonData} modalView={true} />
			<Text m={{ b: "0.5rem" }}>
				Torna una lezione come le altre: presenze e pagamenti com'erano prima
				dell'annullamento, e gli abbonati non hanno più questa da recuperare.
			</Text>
			{wasRescheduled && (
				<>
					<Text m={{ b: "0.5rem" }}>
						Questa lezione era stata riprogrammata. Cosa fai della lezione di recupero?
					</Text>
					<RadioBox
						text="Elimina anche il recupero"
						checked={deleteRescheduled === true}
						handleChange={async () => setDeleteRescheduled(true)}
					/>
					<RadioBox
						text="Tieni il recupero"
						checked={deleteRescheduled === false}
						handleChange={async () => setDeleteRescheduled(false)}
					/>
				</>
			)}
			<Div m={{ x: "1rem" }}>
				<Row m={{ t: "1rem" }}>
					<Col p="0">
						<SecondaryButton
							m="auto"
							textColor={theme.colors.gunmetal}
							text={!isRestoring ? "Ripristina" : "Sto ripristinando..."}
							textSize="subheader"
							action={() => !isRestoring && restore()}
						/>
					</Col>
					{!isRestoring && (
						<Col p="0">
							<PrimaryButton
								m="auto"
								bg={theme.colors.gunmetal_fill}
								textColor="white"
								textSize="subheader"
								text="Indietro"
								action={closeModal}
							/>
						</Col>
					)}
				</Row>
			</Div>
		</Container>
	)
}

export default RestoreLessonModal
